/** La cornice dell'interfaccia: barra, tema, accesso e componenti comuni. */
export const guscio = {
  "nav.stack": "Stack",
  "nav.porte": "Porte",
  "nav.attivita": "Attività",
  "nav.impostazioni": "Impostazioni",
  "nav.esci": "Esci",
  "nav.nonTrovata": "Pagina non trovata",
  "nav.tornaStack": "Torna agli stack",
  "tema.acqua": "Acqua",
  "tema.indaco": "Indaco",
  "tema.ametista": "Ametista",
  "tema.ambra": "Ambra",
  "tema.colore": (p: { nome: string }) => `Colore ${p.nome}`,
  "tema.chiaro": "Passa al tema chiaro",
  "tema.scuro": "Passa al tema scuro",
  "pannelli.ridimensiona": "Ridimensiona i pannelli",
  "pannelli.suggerimento": "Trascina per ridistribuire · doppio clic per ripristinare",
  "accesso.titolo": "Accedi a Portman",
  "accesso.utente": "Nome utente",
  "accesso.password": "Password",
  "accesso.entra": "Accedi",
  "primoAvvio.titolo": "Benvenuto in Portman",
  "primoAvvio.intro":
    "Crea l'account amministratore. Sarà l'unico a poter gestire utenti e impostazioni, e potrà crearne altri in seguito.",
  "primoAvvio.token": "Token di primo avvio",
  "primoAvvio.tokenAiuto":
    "Lo trovi nel log di avvio di Portman, ad esempio con docker compose logs portman. Dimostra che sei tu a gestire la macchina.",
  "primoAvvio.passwordAiuto": "Almeno 12 caratteri. Una passphrase lunga è più sicura e più facile da ricordare.",
  "primoAvvio.ripeti": "Ripeti la password",
  "primoAvvio.discordanti": "Le due password non coincidono.",
  "primoAvvio.crea": "Crea l'amministratore",
};
